import React from 'react';
import AppHeader from '../components/AppHeader';

export default function PolitiqueConfidentialite({ onNavigate, large, toggleText, scale = 1, t, isRTL, lang, switchLang, onDiagnostic }) {
  const isMobile = window.innerWidth < 768;

  const section = (title, children) => (
    <div style={{ marginBottom: 28 }}>
      <div style={{
        fontFamily: 'Fraunces, serif',
        fontSize: (isMobile ? 15 : 17) * scale,
        fontWeight: 700, color: '#003189', marginBottom: 10,
      }}>
        {title}
      </div>
      <div style={{ fontSize: (isMobile ? 13 : 14) * scale, color: '#333', lineHeight: 1.7 }}>
        {children}
      </div>
    </div>
  );

  return (
    <div style={{ minHeight: '100vh', direction: isRTL ? 'rtl' : 'ltr', background: '#F5F5FE' }}>
      <AppHeader
        onNavigate={onNavigate} large={large} toggleText={toggleText}
        t={t} isRTL={isRTL} lang={lang} switchLang={switchLang} onDiagnostic={onDiagnostic}
      />

      <main style={{ maxWidth: 760, margin: '0 auto', padding: isMobile ? '2rem 1rem 4rem' : '3rem 1.5rem 5rem' }}>

        {/* Bouton retour */}
        <button
          onClick={() => onNavigate('home')}
          style={{
            display: 'inline-flex', alignItems: 'center', gap: 6,
            background: 'none', border: 'none', color: '#0063CB',
            fontSize: 13 * scale, fontWeight: 600, cursor: 'pointer',
            padding: 0, marginBottom: 28, fontFamily: 'DM Sans, sans-serif',
          }}>
          ← Retour à l'accueil
        </button>

        {/* Titre */}
        <div style={{
          background: '#003189', borderRadius: isMobile ? 16 : 20,
          padding: isMobile ? '1.5rem 1.2rem' : '2rem 2rem',
          marginBottom: 32,
        }}>
          <div style={{
            fontFamily: 'Fraunces, serif',
            fontSize: isMobile ? 22 * scale : 28 * scale,
            fontWeight: 700, color: '#fff', marginBottom: 8,
          }}>
            Politique de confidentialité
          </div>
          <div style={{ fontSize: (isMobile ? 12 : 13) * scale, color: 'rgba(255,255,255,0.75)' }}>
            DémarchesClaires — Dernière mise à jour : mai 2026
          </div>
        </div>

        {/* Contenu */}
        <div style={{
          background: '#fff', border: '1.5px solid #E0E0EE',
          borderRadius: isMobile ? 16 : 20,
          padding: isMobile ? '1.4rem 1.2rem' : '2rem 2rem',
        }}>

          {section("1. Qui sommes-nous ?", (
            <p>
              DémarchesClaires (demarchesclaires.fr) est un service gratuit d'aide aux démarches
              administratives en ligne, créé par Olivier Scafi. Ce service est accessible sans
              inscription et sans création de compte.
            </p>
          ))}

          {section("2. Données collectées", (
            <>
              <p style={{ marginBottom: 10 }}>
                <strong>Données que vous nous transmettez volontairement :</strong>
              </p>
              <ul style={{ paddingLeft: 20, marginBottom: 12 }}>
                <li>Via le formulaire de contact : nom, adresse email (optionnel), message.</li>
                <li>Via le module d'analyse IA : le texte du courrier que vous collez ou saisissez.
                  Ce texte est transmis à l'API Mistral AI pour analyse et n'est pas conservé sur nos serveurs.</li>
              </ul>
              <p style={{ marginBottom: 10 }}>
                <strong>Données collectées automatiquement :</strong>
              </p>
              <ul style={{ paddingLeft: 20 }}>
                <li>Statistiques de visite anonymisées (Vercel Analytics, Google Analytics) :
                  pages visitées, durée de visite, pays d'origine. Aucune donnée personnelle identifiable.</li>
                <li>Préférence de langue stockée dans votre navigateur (localStorage) — uniquement en local,
                  jamais transmise à nos serveurs.</li>
                <li>Progression dans les modules (localStorage) — uniquement en local.</li>
              </ul>
            </>
          ))}

          {section("3. Finalité du traitement", (
            <ul style={{ paddingLeft: 20 }}>
              <li>Répondre à vos messages de contact.</li>
              <li>Vous fournir une analyse de vos courriers via l'IA Mistral.</li>
              <li>Améliorer le service grâce aux statistiques de visite anonymisées.</li>
            </ul>
          ))}

          {section("4. Partage des données", (
            <>
              <p style={{ marginBottom: 10 }}>
                Vos données ne sont jamais vendues ni transmises à des tiers à des fins commerciales.
              </p>
              <p style={{ marginBottom: 10 }}>
                <strong>Sous-traitants techniques :</strong>
              </p>
              <ul style={{ paddingLeft: 20 }}>
                <li><strong>Mistral AI</strong> — traitement des textes soumis à l'analyse IA (France/UE).
                  Politique de confidentialité : mistral.ai/privacy</li>
                <li><strong>Formspree</strong> — réception des messages du formulaire de contact (USA).
                  Politique : formspree.io/legal/privacy-policy</li>
                <li><strong>Vercel</strong> — hébergement du site (USA, données anonymisées uniquement).</li>
                <li><strong>Google Analytics</strong> — statistiques de visite anonymisées.</li>
              </ul>
            </>
          ))}

          {section("5. Durée de conservation", (
            <ul style={{ paddingLeft: 20 }}>
              <li>Messages de contact : conservés le temps nécessaire au traitement, maximum 12 mois.</li>
              <li>Textes soumis à l'IA : non conservés — traitement immédiat et suppression.</li>
              <li>Statistiques anonymisées : 26 mois (durée légale Google Analytics).</li>
            </ul>
          ))}

          {section("6. Vos droits (RGPD)", (
            <>
              <p style={{ marginBottom: 10 }}>
                Conformément au Règlement Général sur la Protection des Données (RGPD), vous disposez des droits suivants :
              </p>
              <ul style={{ paddingLeft: 20, marginBottom: 12 }}>
                <li>Droit d'accès à vos données personnelles</li>
                <li>Droit de rectification</li>
                <li>Droit à l'effacement ("droit à l'oubli")</li>
                <li>Droit à la limitation du traitement</li>
                <li>Droit d'opposition</li>
              </ul>
              <p>
                Pour exercer ces droits, contactez-nous via le formulaire de contact disponible sur la page d'accueil,
                ou par email à : <strong>contact@demarchesclaires.fr</strong>
              </p>
            </>
          ))}

          {section("7. Cookies", (
            <p>
              DémarchesClaires n'utilise pas de cookies publicitaires ou de tracking. Les seuls
              cookies utilisés sont ceux de Google Analytics (mesure d'audience anonymisée) et les
              données stockées en localStorage dans votre navigateur (langue, progression) —
              ces dernières ne quittent jamais votre appareil.
            </p>
          ))}

          {section("8. Sécurité", (
            <p>
              Le site est hébergé sur Vercel avec HTTPS obligatoire. La clé API Mistral est stockée
              de manière sécurisée dans les variables d'environnement Vercel et n'est jamais exposée
              dans le code source public.
            </p>
          ))}

          {section("9. Contact & réclamation", (
            <>
              <p style={{ marginBottom: 10 }}>
                Pour toute question relative à la protection de vos données :
                formulaire de contact sur la page d'accueil ou email à contact@demarchesclaires.fr
              </p>
              <p>
                Vous pouvez également déposer une réclamation auprès de la CNIL (cnil.fr)
                si vous estimez que vos droits ne sont pas respectés.
              </p>
            </>
          ))}

        </div>

        {/* Retour */}
        <div style={{ textAlign: 'center', marginTop: 32 }}>
          <button
            onClick={() => onNavigate('home')}
            style={{
              background: '#003189', color: '#fff', border: 'none',
              padding: '12px 28px', borderRadius: 12,
              fontSize: 14 * scale, fontWeight: 700, cursor: 'pointer',
              fontFamily: 'DM Sans, sans-serif',
            }}
            onMouseEnter={e => { e.currentTarget.style.background = '#0063CB'; }}
            onMouseLeave={e => { e.currentTarget.style.background = '#003189'; }}>
            ← Retour à l'accueil
          </button>
        </div>

      </main>
    </div>
  );
}
